import { Stack } from '@mui/material';
import {
    FormSkeletonProps,
    SKELETON_INPUT_HEIGHT,
    SKELETON_BUTTON_HEIGHT,
    SKELETON_BUTTON_WIDTH,
} from '../Skeleton.types';
import { SkeletonBox } from './SkeletonBox';

export const FormSkeleton = ({ hasActions = true, sx }: FormSkeletonProps) => {
    return (
        <Stack spacing={3} sx={sx}>
            <Stack spacing={1.25}>
                <SkeletonBox width={248} height={SKELETON_INPUT_HEIGHT} />
                <SkeletonBox width="100%" height={SKELETON_INPUT_HEIGHT} />
                <Stack direction="row" spacing={1.5}>
                    <SkeletonBox width="50%" height={SKELETON_INPUT_HEIGHT} />
                    <SkeletonBox width="50%" height={SKELETON_INPUT_HEIGHT} />
                </Stack>
            </Stack>

            <Stack spacing={1.25}>
                <SkeletonBox width={240} height={SKELETON_INPUT_HEIGHT} />
                <SkeletonBox width="100%" height={SKELETON_INPUT_HEIGHT} />
            </Stack>

            {hasActions && (
                <Stack direction="row" spacing={2}>
                    <SkeletonBox width={SKELETON_BUTTON_WIDTH} height={SKELETON_BUTTON_HEIGHT} />
                    <SkeletonBox width={SKELETON_BUTTON_WIDTH} height={SKELETON_BUTTON_HEIGHT} />
                </Stack>
            )}
        </Stack>
    );
};
